/** @format */
import { apiRequest } from "../Component/Utils/ApiHundler";

const apiURL = process.env.REACT_APP_API_URL;

export default async function getDocs(instance, client, token) {
  const apiUrl = `${apiURL}/admin/document/list`;
  let bodyData = JSON.stringify({
    "InstanceId": instance,
    "ClientId": client
  });

  const data = await apiRequest(apiUrl, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      Authorization: token,
    },
    body: bodyData
  });

  return data.message.list;
}